
import axios from 'axios';
//import store from "/src/store";
import i18n from "/src/i18n";
import store from "../../store"

export function ValidateIsPlanActive(idPersonStudent, authToken) {

    return new Promise((resolve, reject) => {
        return axios({
            method: "GET",
            url: `${process.env.VUE_APP_API_URL}/resources/Groups/ValidateIsPlanActive?idPersonStudent=${idPersonStudent}`,
            headers: { 'Authorization': 'Bearer ' + authToken }
        }).then(response => {
            resolve(response.data.return);
        })
            .catch(error => {
                reject(error);
            });
    })
}

export function showSidebar(user, step, datosSidebar) {

    //$store.state.datosSidebar.typeScheduled
    let element = document.getElementById("main-wrapper");
    if (typeof (element) != 'undefined' && element != null) {
        element.classList.remove("sidebar-hide");
    }
}
export function hideSidebar(user, step, datosSidebar) {

    //let step = this.tabIndex;

    let element = document.getElementById("main-wrapper");
    if (typeof (element) != 'undefined' && element != null) {
        if ((user == null) || (step == 1 || step == 2 || step == 3 || step == 4) || (user.personsTypeId == Constants.PERFILES.ALUMNO && datosSidebar != null && !datosSidebar.flagPurchaseHistory && !datosSidebar.flagActivePlan)) {
            element.classList.add("sidebar-hide");
        } else {
            element.classList.remove("sidebar-hide");
        }
    }

}
export function hideSidebarNav(user, datosSidebar) {
    let element = document.getElementById("main-wrapper");
    if (typeof (element) != 'undefined' && element != null) {

        if ((user == null) || (!datosSidebar.flagPurchaseHistory && !datosSidebar.flagActivePlan && user.personsTypeId == Constants.PERFILES.ALUMNO)) {
            element.classList.add("sidebar-hide");
        } else {
            element.classList.remove("sidebar-hide");
        }
    }


}

import * as Constants from "@/assets/js/appConstants";

export function horarioObtenerColorClase(stateClass) {
    let colorResquest = "";
    switch (stateClass) {
        case Constants.CALENDAR_STATUS.CONFIRM.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.CONFIRM.COLOR;
            break;
        case Constants.CALENDAR_STATUS.PENDIENT.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR;
            break;
        case Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.CANCELED_STUDENT.COLOR;
            break;
        case Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.CANCELED_TEACHER.COLOR;
            break;
        case Constants.CALENDAR_STATUS.COMPLETED.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.COMPLETED.COLOR;
            break;

        case Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.COLOR;
            break;
        case Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.COLOR;
            break;
        case Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.PENDING_REPORT.COLOR;
            break;
        case Constants.CALENDAR_STATUS.FROZEN.VALUE:
            colorResquest = Constants.CALENDAR_STATUS.FROZEN.COLOR;
            break;
    }

    return colorResquest;
}
export function horarioObtenerColorClaseConsolidado(stateClass) {
    let colorResquest = "";
    switch (stateClass) {
        case Constants.CALENDAR_STATUS_CONSOLIDATED.CONFIRM.VALUE:
            colorResquest = Constants.CALENDAR_STATUS_CONSOLIDATED.CONFIRM.COLOR;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.PENDIENT.VALUE:
            colorResquest = Constants.CALENDAR_STATUS_CONSOLIDATED.PENDIENT.COLOR;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.CANCELED_STUDENT.VALUE:
            colorResquest = Constants.CALENDAR_STATUS_CONSOLIDATED.CANCELED_STUDENT.COLOR;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.COMPLETED.VALUE:
            colorResquest = Constants.CALENDAR_STATUS_CONSOLIDATED.COMPLETED.COLOR;
            break;

        case Constants.CALENDAR_STATUS_CONSOLIDATED.UNATTENDANCE_TEACHER.VALUE:
            colorResquest = Constants.CALENDAR_STATUS_CONSOLIDATED.UNATTENDANCE_TEACHER.COLOR;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.UNATTENDANCE_STUDENT.VALUE:
            colorResquest = Constants.CALENDAR_STATUS_CONSOLIDATED.UNATTENDANCE_STUDENT.COLOR;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.FROZEN.VALUE:
            colorResquest = Constants.CALENDAR_STATUS_CONSOLIDATED.FROZEN.COLOR;
            break;
    }

    return colorResquest;
}

export function horarioObtenerNameClaseEnEs(stateClass) {
    let nameClass = "";

    //console.log("stateClass: ",stateClass)
    switch (stateClass) {
        case Constants.CALENDAR_STATUS.CONFIRM.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.CONFIRMED.ES : Constants.STATUS_CLASS.CONFIRMED.EN;
            break;
        case Constants.CALENDAR_STATUS.PENDIENT.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.PENDING.ES : Constants.STATUS_CLASS.PENDING.EN;
            break;
        case Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.CANCELED_STUDENT.ES : Constants.STATUS_CLASS.CANCELED_STUDENT.EN;
            break;
        case Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.CANCELED_TEACER.ES : Constants.STATUS_CLASS.CANCELED_TEACER.EN;
            break;
        case Constants.CALENDAR_STATUS.COMPLETED.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.COMPLETED.ES : Constants.STATUS_CLASS.COMPLETED.EN;
            break;

        case Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.ABSENCE_TEACHER.ES : Constants.STATUS_CLASS.ABSENCE_TEACHER.EN;
            break;
        case Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.ABSENCE_STUDENT.ES : Constants.STATUS_CLASS.ABSENCE_STUDENT.EN;
            break;
        case Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.COMPLETED_REPORT.ES : Constants.STATUS_CLASS.COMPLETED_REPORT.EN;
            break;

        case Constants.CALENDAR_STATUS.FROZEN.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS.FRONZE_CLASS.ES : Constants.STATUS_CLASS.FRONZE_CLASS.EN;
            break;


    }

    return nameClass;
}
export function horarioObtenerNameClaseEnEsConsolidado(stateClass) {
    let nameClass = "";
    switch (stateClass) {
        case Constants.CALENDAR_STATUS_CONSOLIDATED.CONFIRM.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS_CONSOLIDATED.CONFIRMED.ES : Constants.STATUS_CLASS_CONSOLIDATED.CONFIRMED.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.PENDIENT.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS_CONSOLIDATED.PENDING.ES : Constants.STATUS_CLASS_CONSOLIDATED.PENDING.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.CANCELED_STUDENT.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS_CONSOLIDATED.CANCELED_STUDENT.ES : Constants.STATUS_CLASS_CONSOLIDATED.CANCELED_STUDENT.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.COMPLETED.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS_CONSOLIDATED.COMPLETED.ES : Constants.STATUS_CLASS_CONSOLIDATED.COMPLETED.EN;
            break;

        case Constants.CALENDAR_STATUS_CONSOLIDATED.UNATTENDANCE_TEACHER.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS_CONSOLIDATED.ABSENCE_TEACHER.ES : Constants.STATUS_CLASS_CONSOLIDATED.ABSENCE_TEACHER.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.UNATTENDANCE_STUDENT.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS_CONSOLIDATED.ABSENCE_STUDENT.ES : Constants.STATUS_CLASS_CONSOLIDATED.ABSENCE_STUDENT.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.FROZEN.VALUE:
            nameClass = localStorage.getItem('lang') == "es" ? Constants.STATUS_CLASS_CONSOLIDATED.FRONZE_CLASS.ES : Constants.STATUS_CLASS_CONSOLIDATED.FRONZE_CLASS.EN;
            break;
    }

    return nameClass;
}
export function horarioObtenerNameClaseEN(stateClass) {
    let nameClass = "";
    switch (stateClass) {
        case Constants.CALENDAR_STATUS.CONFIRM.VALUE:
            nameClass = Constants.STATUS_CLASS.CONFIRMED.EN;
            break;
        case Constants.CALENDAR_STATUS.PENDIENT.VALUE:
            nameClass = Constants.STATUS_CLASS.PENDING.EN;
            break;
        case Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE:
            nameClass = Constants.STATUS_CLASS.CANCELED_STUDENT.EN;
            break;
        case Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE:
            nameClass = Constants.STATUS_CLASS.CANCELED_TEACER.EN;
            break;
        case Constants.CALENDAR_STATUS.COMPLETED.VALUE:
            nameClass = Constants.STATUS_CLASS.COMPLETED.EN;
            break;
        case Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE:
            nameClass = Constants.STATUS_CLASS.ABSENCE_TEACHER.EN;
            break;
        case Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE:
            nameClass = Constants.STATUS_CLASS.ABSENCE_STUDENT.EN;
            break;
        case Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE:
            nameClass = Constants.STATUS_CLASS.COMPLETED_REPORT.EN;
            break;
        case Constants.CALENDAR_STATUS.FROZEN.VALUE:
            nameClass = Constants.STATUS_CLASS.FRONZE_CLASS.EN;
            break;
    }

    return nameClass;
}

export function horarioObtenerNameClaseENConsolidado(stateClass) {
    let nameClass = "";
    switch (stateClass) {
        case Constants.CALENDAR_STATUS_CONSOLIDATED.CONFIRM.VALUE:
            nameClass = Constants.STATUS_CLASS_CONSOLIDATED.CONFIRMED.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.PENDIENT.VALUE:
            nameClass = Constants.STATUS_CLASS_CONSOLIDATED.PENDING.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.CANCELED_STUDENT.VALUE:
            nameClass = Constants.STATUS_CLASS_CONSOLIDATED.CANCELED_STUDENT.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.COMPLETED.VALUE:
            nameClass = Constants.STATUS_CLASS_CONSOLIDATED.COMPLETED.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.UNATTENDANCE_TEACHER.VALUE:
            nameClass = Constants.STATUS_CLASS_CONSOLIDATED.ABSENCE_TEACHER.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.UNATTENDANCE_STUDENT.VALUE:
            nameClass = Constants.STATUS_CLASS_CONSOLIDATED.ABSENCE_STUDENT.EN;
            break;
        case Constants.CALENDAR_STATUS_CONSOLIDATED.FROZEN.VALUE:
            nameClass = Constants.STATUS_CLASS_CONSOLIDATED.FRONZE_CLASS.EN;
            break;
    }

    return nameClass;
}

export function redirectHorarioAnt(typeScheduled, currentPathName, self) {

    let pathName = typeScheduled == 0 ? '/horario' : typeScheduled == 1 ? '/horario/calendario/public' : typeScheduled == 2 ? '/horario/calendario/private' : '/horario/clases'

    if (currentPathName != pathName)
        self.$router.push(pathName);
}

export function redirectHorario(typeScheduled, self, is_representative) {

    let redirect = "/horario";
    if (is_representative) {
        switch (typeScheduled) {
            case Constants.TYPE_SCHEDULED.UNPROGRAMMED:
                redirect = '/horario';
                break;
            case Constants.TYPE_SCHEDULED.MASS_REQUEST:
                redirect = '/horario/calendario/public';
                break;
            case Constants.TYPE_SCHEDULED.DIRECT_REQUEST:
                redirect = '/horario/calendario/private';
                break;
            case Constants.TYPE_SCHEDULED.SCHEDULED:
                redirect = '/horario/clases';
                //redirect = '/horario/clases-merge';
                break;
        }
    } else {
        if (typeScheduled == Constants.TYPE_SCHEDULED.SCHEDULED) {
            redirect = '/horario/clases';
        }
    }

    self.$router.push({ path: redirect }).catch(err => { });
    //$store.state.datosSidebar.typeScheduled == 0 ? '/horario': $store.state.datosSidebar.typeScheduled == 1 ? '/horario/calendario/public' : $store.state.datosSidebar.typeScheduled == 2 ?'/horario/calendario/private' : '/horario/clases'
}


export function redirectHorarioUpdate(typeScheduled, self, is_representative, dataStudent) {


    let redirect = "horario";
    let params = null
    if (is_representative) {
        switch (typeScheduled) {
            case Constants.TYPE_SCHEDULED.UNPROGRAMMED:
                redirect = 'horario';
                break;
            case Constants.TYPE_SCHEDULED.MASS_REQUEST:
                redirect = 'horario-calendario';
                params = 'public'
                break;
            case Constants.TYPE_SCHEDULED.DIRECT_REQUEST:
                redirect = 'horario-calendario';
                params = 'private'
                break;
            case Constants.TYPE_SCHEDULED.SCHEDULED:
                redirect = 'horario-calendario-clases';
                params
                break;
        }
    } else {
        if (typeScheduled == Constants.TYPE_SCHEDULED.SCHEDULED) {
            redirect = 'horario-calendario-clases';
        }
    }
    self.$router.push({
        name: redirect, params: {
            id: params,
            student: dataStudent
        }
    }).catch(err => { });
    //$store.state.datosSidebar.typeScheduled == 0 ? '/horario': $store.state.datosSidebar.typeScheduled == 1 ? '/horario/calendario/public' : $store.state.datosSidebar.typeScheduled == 2 ?'/horario/calendario/private' : '/horario/clases'
}

export function getFormatDate(startDate, endDate, lang, flagPlanTest, maximunHours) {
    let dateStart = new Date(startDate);
    let dateFinish = new Date(endDate);
    let days = localStorage.getItem('lang') == "es" ? Constants.DIA_SEMANA.ES : Constants.DIA_SEMANA.EN;
    let monthNames = localStorage.getItem('lang') == "es" ? Constants.MESES.ES : Constants.MESES.EN;

    if (flagPlanTest) {
        let dateFormat = new Date(startDate)
        let dateClassPlan = dateFormat.setMinutes(dateFormat.getMinutes() + maximunHours * 60)
        return `${days[dateStart.getDay()]}, ${dateStart.getDate()} ${monthNames[dateStart.getMonth()]} | ${this.$moment(dateStart).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')} - ${this.$moment(dateClassPlan).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')}`;
    } else {
        return `${days[dateStart.getDay()]}, ${this.$moment(dateStart).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')} - ${this.$moment(dateFinish).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')}`;
    }
    //let days = lang == "es" ? Constants.DIA_SEMANA.ES : Constants.DIA_SEMANA.EN;
    //let monthNames = lang == "es" ? Constants.MESES.ES : Constants.MESES.EN;

    //return `${days[dateStart.getDay()]}, ${dateStart.getDate()} ${monthNames[dateStart.getMonth()]} | ${this.$moment(dateStart).format("h:mma")} - ${this.$moment(dateFinish).format("h:mma")}`;


}

export function getFormatDateComplete(startDate, endDate, lang, flagPlanTest, maximunHours) {

    let dateStart = new Date(startDate);
    let dateFinish = new Date(endDate);

    let days = localStorage.getItem('lang') == "es" ? Constants.DIA_SEMANA.ES : Constants.DIA_SEMANA.EN;
    let monthNames = localStorage.getItem('lang') == "es" ? Constants.MESES_LONG.ES : Constants.MESES_LONG.EN;

    return `${days[dateStart.getDay()]}, ${dateStart.getDate()} ${monthNames[dateStart.getMonth()]} | ${this.$moment(dateStart).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')} - ${this.$moment(dateFinish).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')}`;

}
export function getFormatDateCompleteTitle(startDate, endDate) {

    let dateStart = new Date(startDate);
    let dateFinish = new Date(endDate);

    let days = localStorage.getItem('lang') == "es" ? Constants.DIA_SEMANA.ES : Constants.DIA_SEMANA.EN;
    let monthNames = localStorage.getItem('lang') == "es" ? Constants.MESES_LONG.ES : Constants.MESES_LONG.EN;

    return `${days[dateStart.getDay()]}, ${this.$moment(dateStart).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')} - ${this.$moment(dateFinish).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')}`;

}
export function getFormatDateCompleteTitleTime(startDate, endDate) {
    let dateStart = new Date(startDate);
    let dateFinish = new Date(endDate);

    let days = localStorage.getItem('lang') == "es" ? Constants.DIA_SEMANA.ES : Constants.DIA_SEMANA.EN;
    let monthNames = localStorage.getItem('lang') == "es" ? Constants.MESES_LONG.ES : Constants.MESES_LONG.EN;

    return `${this.$moment(dateStart).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')} - ${this.$moment(dateFinish).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')}`;

}
export function getFormatDateCompleteClass(startDate, endDate) {

    let dateStart = new Date(startDate);
    let dateFinish = new Date(endDate);

    let days = localStorage.getItem('lang') == "es" ? Constants.DIA_SEMANA.ES : Constants.DIA_SEMANA.EN;
    let monthNames = localStorage.getItem('lang') == "es" ? Constants.MESES_LONG.ES : Constants.MESES_LONG.EN;
    if (localStorage.getItem('lang') == "es") {
        return `${days[dateStart.getDay()]}, ${dateStart.getDate()} de ${monthNames[dateStart.getMonth()]}`;
    }
    else {
        return `${days[dateStart.getDay()]}, ${monthNames[dateStart.getMonth()]} ${dateStart.getDate()}th`;
    }

}

export function getFormatDateCompleteDetail(startDate, endDate) {

    let dateStart = new Date(startDate);
    let dateFinish = new Date(endDate);

    let days = localStorage.getItem('lang') == "es" ? Constants.DIA_SEMANA.ES : Constants.DIA_SEMANA.EN;
    let monthNames = localStorage.getItem('lang') == "es" ? Constants.MESES_LONG.ES : Constants.MESES_LONG.EN;

    return `${days[dateStart.getDay()]}, ${dateStart.getDate()} ${monthNames[dateStart.getMonth()]}, ${this.$moment(dateStart).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')} - ${this.$moment(dateFinish).format("h:mm a").replace('am', 'a.m.').replace('pm', 'p.m.')}`;

}

export function getFormatDateByDay(startDate, endDate) {

    let dateStart = new Date(startDate);
    let dateFinish = new Date(endDate);

    let days = localStorage.getItem('lang') == "es" ? Constants.DIA_SEMANA.ES : Constants.DIA_SEMANA.EN;

    return `${days[dateStart.getDay()]}`;
}

export function getTimeZoneUser(user, step, datosSidebar) {

    let diff = new Date().getTimezoneOffset();
    let sign = Math.sign(diff)
    diff = sign == 1 ? "-" + diff : diff
    return parseInt(diff);
}

export function getTimeZoneNameUser() {
    let timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZoneName ? timeZoneName : "America/Lima";
}

export function getHoursByTimeZoneName(moment, timeZoneName) {
    let GMT = moment().tz(timeZoneName).format("Z");
    let arrGMT = GMT.split(":");
    let textGMT = arrGMT[0] + (arrGMT[1] == "00" ? "" : ":" + arrGMT[1]);

    return `<div>GMT<br>${textGMT}</div>`;
}

export function getCalendarTitle(date, lang) {
    //let arrayMonth = ["Jan","Feb","Mar","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    let arrayMonth = localStorage.getItem('lang') == "es" ? Constants.MESES_LONG.ES : Constants.MESES_LONG.EN;

    let value = `${arrayMonth[date.month]}  ${date.year}`
    // let value = `${arrayMonth[date.date.month-1]} ${date.start.day} - ${date.end.day}, ${date.date.year}`
    return value;
}

export function getCalendarHeaderFormat(moment, date, lang, format) {
    let spanItem1 = document.createElement('div');
    let spanItem2 = document.createElement('div')
    spanItem1.innerHTML = moment(date).lang(lang).format('ddd');
    // debugger;
    if (format != "") {
        spanItem2.innerHTML = moment(date).lang(lang).format(format);///MM
        spanItem2.style.cssText = 'font-size:20px;';
    } else {
        // setTimeout(() => {
        var all1 = document.getElementsByClassName('fc-timegrid-now-indicator-line');

        for (var y = 0; y < all1.length; y++) {
            all1[y].style.display = "none";
        }

        var all2 = document.getElementsByClassName('fc-timegrid-now-indicator-container');

        for (var i = 0; i < all2.length; i++) {
            all2[i].style.background = '#ffffff';
        }
        //spanItem1.style.color="#2b305d";
        spanItem1.style.cssText = 'font-size:15px; color: #2b305d';
        spanItem2.style.display = "none";
        // }, 100);


    }
    let arrayOfDomNodes = [spanItem1, spanItem2]
    return { domNodes: arrayOfDomNodes }
}

/*export function getCalendarHeaderFormat(moment, date, lang, onlyDayOfWweek = false) {
    let spanItem1 = document.createElement('div');
    let spanItem2 = document.createElement('div')
    spanItem1.innerHTML = moment(date).lang(lang).format('ddd');
    if(!onlyDayOfWweek){
        spanItem2.innerHTML = moment(date).lang(lang).format('DD');///MM
        spanItem2.style.cssText = 'font-size:20px;';
    }

    let arrayOfDomNodes = [ spanItem1, spanItem2 ]
    return { domNodes: arrayOfDomNodes }
} */

export function getCalendarEventTimeFormat() {

    return {
        hour: 'numeric',
        minute: '2-digit',
        meridiem: 'short',
        omitZeroMinute: true,
    }
}

export function getCalendarHeaderToolbar(flagShowHeader) {
    if (flagShowHeader) {
        return {
            left: "today, prev next",
            center: 'title',
            right: '',
        }
    }

    return {
        left: "",
        center: '',
        right: '',
    }

}

export function openLinkClass(linkClass, moment, startDate, endDate, userTimeZone) {

    let result = getAccessClass(moment, startDate, endDate, userTimeZone);
    if (result == "") {
        let url = linkClass;
        window.open(url, '_blank');
        return "";
    }
    else {
        return result;
    }
}

export function getAccessClass(moment, startDate, endDate, userTimeZone) {

    //is_teacher

    let minutes = `${process.env.VUE_APP_MINUTES_PREV_CLASS}`;
    let p_dateNow = new Date();
    let dateNow = new Date(convertTimeToUserTime(p_dateNow, userTimeZone, moment));
    let dateStart = new Date(moment(startDate).add(-parseInt(minutes), 'minutes'));
    let dateEnd = new Date(endDate);

    if (dateNow < dateStart) {
        return i18n.t('reusables.entrance-to-class', { NRO: minutes.toString() });
    }
    else if (dateNow > dateEnd) {
        return i18n.t('reusables.cant-enter-class');
    }
    else {
        return "";
    }
}

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export function deleteCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function setCookie(cname, cvalue) {
    window.document.cookie = cname + "=" + cvalue + ";";
}

var interval;
export function openNiubizCheckoutForm(p_merchantid, p_sessiontoken, amount, purchasenumber, idData, urlVisanet, urlSite) {

    window.VisanetCheckout.configure({
        sessiontoken: p_sessiontoken,
        channel: 'web',
        merchantid: p_merchantid,
        purchasenumber: purchasenumber,
        amount: amount,
        expirationminutes: '20',
        timeouturl: process.env.VUE_APP_NIUBIZ_TIMEOUT_URL,
        merchantlogo: 'https://english-advance-qa.cloudapp.pe/img/big-logo.02a7ce03.png',
        formbuttoncolor: '#000000',

        action: process.env.VUE_APP_NIUBIZ_POST_URL + idData,
        complete: function (params) {
            // debugger;
            store.commit('mutateIsAlertWindow', true);
            alert(JSON.stringify(params));
            //TODO: ir a pagina de exito
        }
    });
    //   this.$store.dispatch('mutateIsAlertWindow', false);
    window.VisanetCheckout.open();


}


export function convertTimeToUTC(time, userTimeZone, moment) {
    //console.log("VUE_APP_TIMEZONE: " + process.env.VUE_APP_TIMEZONE)

    let timeWithoutTZ = moment(time).format('YYYY-MM-DDTHH:mm:ss');
    //console.log("timeWithoutTZ: " + timeWithoutTZ);
    let timeUTC = moment.tz(timeWithoutTZ, moment.ISO_8601, userTimeZone).utc().format();
    //console.log("local time UTC: " + timeUTC);

    //let timeGeneral = moment(timeUTC).tz(process.env.VUE_APP_TIMEZONE).format('YYYY-MM-DDTHH:mm:ss');
    //console.log("local time general: " + timeGeneral);
    return timeUTC;
}
export function convertTimeToUTCEnd(time, userTimeZone, moment) {
    let timeWithoutTZ = moment(time).format('YYYY-MM-DDTHH:mm:ss');
    let timeUTC = moment.tz(timeWithoutTZ, moment.ISO_8601, userTimeZone).utc().add(1, 'day').format();
    return timeUTC;
}
export function convertTimeToUserTime(time, userTimeZone, moment) {
    let timeUser = moment(moment(time).utc()).tz(userTimeZone).format('YYYY-MM-DDTHH:mm:ss');
    //console.log("user time: " + timeUser);
    return timeUser;
}
export function convertTimeToUserTimeFormat(time, userTimeZone, moment, format) {
    moment.updateLocale('es', {
        meridiem(hour, minute, isLowerCase) {
            return hour < 12 ? 'a.m.' : 'p.m.';
        }
    });
    //debugger;
    let timeUser = moment(moment(time).utc()).tz(userTimeZone).format(format);
    //console.log("user time zone: " + timeUser);
    return timeUser;
}

export function convertTimeCalendarEvents(events, userTimeZone, moment) {
    var _startTime = null;
    var _endTime = null;
    events.forEach((element) => {
        _startTime = convertTimeToUTC(element.StartDate, userTimeZone, moment);
        _endTime = convertTimeToUTC(element.EndDate, userTimeZone, moment);

        element.StartDate = _startTime;
        element.EndDate = _endTime;
        element.StartDateTz = _startTime;
        element.EndDateTz = _endTime;
    });
    return events;
}


export function convertToUserTimeCalendarEvents(events, userTimeZone, moment) {
    events.forEach((element) => {

        element.startDate = convertTimeToUserTime(element.startDate, userTimeZone, moment);
        element.endDate = convertTimeToUserTime(element.endDate, userTimeZone, moment);
    });

    return events;
}

export function getNextClassDate(date, userTimeZone, moment, format) {

    return convertTimeToUserTimeFormat(date, userTimeZone, moment, format);
}

export function getNextClassTime(startDate, endDate, userTimeZone, moment, format) {
    let _start_time = convertTimeToUserTimeFormat(startDate, userTimeZone, moment, format);
    let _end_time = convertTimeToUserTimeFormat(endDate, userTimeZone, moment, format);

    return `${_start_time} - ${_end_time}`;
}

export function getCourseColors(value) {
    switch (value) {
        case Constants.COURSE_STATUS.VALUE1.ID:
            return Constants.COURSE_STATUS.VALUE1.COLOR;
        case Constants.COURSE_STATUS.VALUE2.ID:
            return Constants.COURSE_STATUS.VALUE2.COLOR;
        case Constants.COURSE_STATUS.VALUE3.ID:
            return Constants.COURSE_STATUS.VALUE3.COLOR;
        case Constants.COURSE_STATUS.VALUE4.ID:
            return Constants.COURSE_STATUS.VALUE4.COLOR;
    }
}

export function getCourseStateName(value) {
    switch (value) {
        case Constants.COURSE_STATUS.VALUE1.ID:
            return Constants.COURSE_STATUS.VALUE1.NAME_EN;
        case Constants.COURSE_STATUS.VALUE2.ID:
            return Constants.COURSE_STATUS.VALUE2.NAME_EN;
        case Constants.COURSE_STATUS.VALUE3.ID:
            return Constants.COURSE_STATUS.VALUE3.NAME_EN;
        case Constants.COURSE_STATUS.VALUE4.ID:
            return Constants.COURSE_STATUS.VALUE4.NAME_EN;
    }
}

export function ValidarMergeHorarios(listaHorarios, _fechaInicio, _fechaFin, moment) {

    let _eventItemTmp = {};

    listaHorarios.every((eventItem) => {
        if (eventItem !== null && typeof eventItem != 'undefined' && eventItem.editable) {

            if (moment(_fechaInicio).format('YYYY-MM-DD HH:mm') == moment(eventItem.end).format('YYYY-MM-DD HH:mm') && moment(_fechaInicio).hour() != 0) {
                eventItem.end = moment(_fechaFin).format('YYYY-MM-DDTHH:mm:ss');
                _eventItemTmp = eventItem;
                //console.log("ValidarMergeHorarios primero")
                return false;
            }
            else if (moment(_fechaFin).format('YYYY-MM-DD HH:mm') == moment(eventItem.start).format('YYYY-MM-DD HH:mm') && moment(_fechaFin).hour() != 0) {

                eventItem.start = moment(_fechaInicio).format('YYYY-MM-DDTHH:mm:ss');
                _eventItemTmp = eventItem;
                //console.log("ValidarMergeHorarios segundo")
                return false;
            }

        }
        return true;
    });

    return _eventItemTmp;
}

export function ValidarMergeHorariosByRecurrent(listaHorarios, _fechaInicio, _fechaFin, moment, noRecurrent) {

    let _eventItemTmp = {};

    listaHorarios.every((eventItem) => {
        if (eventItem !== null && typeof eventItem != 'undefined' && eventItem.editable) {
            if (eventItem.noRecurrent === noRecurrent) {
                if (moment(_fechaInicio).format('YYYY-MM-DD HH:mm') == moment(eventItem.end).format('YYYY-MM-DD HH:mm') && moment(_fechaInicio).hour() != 0) {
                    eventItem.end = moment(_fechaFin).format('YYYY-MM-DDTHH:mm:ss');
                    _eventItemTmp = eventItem;
                    //console.log("ValidarMergeHorarios primero")
                    return false;
                }
                else if (moment(_fechaFin).format('YYYY-MM-DD HH:mm') == moment(eventItem.start).format('YYYY-MM-DD HH:mm') && moment(_fechaFin).hour() != 0) {

                    eventItem.start = moment(_fechaInicio).format('YYYY-MM-DDTHH:mm:ss');
                    _eventItemTmp = eventItem;
                    //console.log("ValidarMergeHorarios segundo")
                    return false;
                }
            }
        }
        return true;
    });

    return _eventItemTmp;
}